export default {
    loading_content: "Estem carregant el teu contingut",
    wellcome: "Benvingut a BrainsPro!",
    redirect_academy: "En uns moments seràs redirigit a la teva acadèmia.",
    first: "Primera",
    last: "Última",
    next: "Següent",
    page: "Pàgina",
    previous: "Anterior",

    // PaginationControls
    pagination: 'Paginació',
    showing_results: 'Mostrant {from}-{to} de {total}',
    page_of: 'Pàgina {page} de {pages}',
    go_to_page: 'Anar a la pàgina {page}',
}
